const selectors = {
	addToCartForm: "[data-add-to-cart-upsell]",
	name: "[name='id']",
	properties: "[name^='properties']"
};

class CartUpsellCard extends HTMLElement {
	constructor() {
		super();

		this.initCartUpsellCard();
	}

	initCartUpsellCard() {
		// console.log("initCartUpsellCard");

		this.addToCartForm = this.querySelector(selectors.addToCartForm);

		this.productId = this.addToCartForm.querySelector(selectors.name);
		this.allProperties = this.addToCartForm.querySelectorAll(selectors.properties);

		this.addToCartForm.addEventListener(
			"click",
			this.addToCart.bind(this)
		);

	}

	addToCart(e) {
		e.preventDefault();      
        sampleChosen();
      
		let productId = this.productId.value;

		this.addToCartItem(productId);
	}
	addToCartItem(productId) {
		let formData = {
			items: [
				{
					id: +productId,
					quantity: 1
				}
			]
		};
		fetch(window.Shopify.routes.root + "cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(formData)
		})
			.then((response) => {
				return response.json();
			})
			.then(() => {
				document.dispatchEvent(new CustomEvent("minicart:update"));
			})
			.catch((error) => {
				console.error("Error:", error);
			});
	}
}

customElements.define('cart-upsell-card', CartUpsellCard);

  function sampleChosen(){
    console.log("sample chosen. disable other options");
    var upsellBtns = document.getElementsByClassName("cart-upsell-card__form-button"); 
    for (var i = 0; i < upsellBtns.length; i++) { 
        upsellBtns[i].disabled = true;
        upsellBtns[i].style.display = 'none';
    }
  }
